import React from "react"
import { useParams } from "react-router-dom"
import { useTranslate } from "ra-core"
import { Box } from "@mui/material"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import { List, TopToolbar, CreateButton, SelectColumnsButton } from "react-admin"
import { ScheduleDataGrid } from "components/schedule"

const ScheduleList = ({id}: {id: string}) => {
    const translate = useTranslate()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "companies", icon: <ScheduleIcon/> },
    ]

    return (
            <Box display="flex" flexDirection="column" width="100%">
                <Box mb={1}>
                    <RecordActionsTabs subTabs={subTabs} resourceParent="companies"/>
                </Box>
                <Box display="flex" justifyContent="flex-end">
                    <TopToolbar>
                        <CreateButton resource={`companies/${id}/schedules`}/>
                        <SelectColumnsButton />
                    </TopToolbar>
                </Box>
            </Box>
        )
}

const Schedule = () => {
    const translate = useTranslate()
    const { id } = useParams<{ id: string }>()

    return (
        <List
            resource={`schedules/entity/company/${id}`}
            title={translate('resources.schedules.name')}
            actions={<ScheduleList id={id!}/>}
            empty={false}
        >
            <ScheduleDataGrid resource={`/companies/${id}/schedules`} />
        </List>
    )
}

export default Schedule
